import Text from '../../../atoms/Text';

interface ITabMobileProps {
  tab: string;
  active: boolean;
  handleClick(): void;
}

const TabMobile = ({ tab, active, handleClick }: ITabMobileProps) => {
  return (
    <div className='dex_trades_mobile__tabs__tab' onClick={handleClick}>
      <Text
        className={`dex_trades_mobile__tabs__tab__text${
          active ? ' dex_trades_mobile__tabs__tab__text--active' : ''
        }`}
        size={14}
      >
        {tab}
      </Text>
    </div>
  );
};

export default TabMobile;
